export enum AmountPercents {
  PERCENT = '%',
  AMOUNT = '$'
}

